/**
 * @file
 * Ensures skip link activation moves keyboard focus to main content.
 */

export function initSkipLinkFocus(Drupal) {
  "use strict";

  function getMainTarget() {
    return (
      document.getElementById("main-content") ||
      document.querySelector("main[role='main']") ||
      document.querySelector("main")
    );
  }

  function focusMainTarget(target) {
    if (!target) {
      return;
    }

    var hadTabindex = target.hasAttribute("tabindex");
    if (!hadTabindex) {
      target.setAttribute("tabindex", "-1");
    }

    try {
      target.scrollIntoView({ block: "start" });
    } catch (e) {
      // Ignore scroll failures.
    }

    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      target.focus();
    }
  }

  function onSkipLinkActivate(event) {
    if (!event.target || typeof event.target.closest !== "function") {
      return;
    }

    var link = event.target.closest("a[href='#main-content']");
    if (!link) {
      return;
    }

    var target = getMainTarget();
    if (!target) {
      return;
    }

    event.preventDefault();
    focusMainTarget(target);

    if (window.location.hash !== "#main-content") {
      window.location.hash = "#main-content";
    }
  }

  Drupal.behaviors.skipLinkFocus = {
    attach: function (context) {
      if (
        !context ||
        context !== document ||
        document.documentElement.dataset.skipLinkFocus === "true"
      ) {
        return;
      }

      document.documentElement.dataset.skipLinkFocus = "true";
      document.addEventListener("click", onSkipLinkActivate, true);
    },
  };
}
